<span style="position:absolute">
    <c11n-checkbox class="compare-tool-checkbox" [labelText]="fundInput.profile.ticker"
        *ngIf='!((comparedFunds.length>=5||fundInput.profile.is529) && !fundInput.compareEnabled)'>
        <input c11nCheckboxInput type="checkbox" [title]="fundInput.profile.ticker+' checkbox'"
            [name]="fundInput.profile.ticker+' checkbox'" [id]="fundInput.profile.ticker + '_compare'"
            (click)="fundAction($event)" [checked]='fundInput.compareEnabled'>
    </c11n-checkbox>
</span>

<span *ngIf='(comparedFunds.length>=5||fundInput.profile.is529) && !fundInput.compareEnabled'
    class="notAvailableText">N/A</span>